import { Button } from '../../../components/ui/button';
import { CountdownInline, GalleryBlock, GiftsBlock, LocationBlock, RsvpBlock, SiteFooter, StoryBlock, renderGalleryByPosition } from '../shared/TemplateBlocks';

export default function ClassicEditorialTemplate(props) {
  const {
    site,
    theme,
    daysUntil,
    weddingDateLabel,
    locationCards,
    availableGifts,
    galleryPosition,
    isTemplatePreview,
    onTemplatePreviewRedirect,
    onOpenRsvp,
    onGiftClick,
    onOpenGallery,
    showCountdown,
    showGiftSection,
    showRsvpCount,
    confirmedGuests
  } = props;

  const galleryNode = (
    <GalleryBlock
      galleryImages={site.gallery_images}
      headingFont={theme.headingFont}
      titleColor={theme.galleryTitleColor || theme.primaryColor}
      secondaryColor={theme.galleryIconColor || theme.secondaryColor}
      sectionBackground={theme.gallerySectionBackground}
      onOpenGallery={onOpenGallery}
      cardClass="rounded-xl"
    />
  );

  return (
    <>
      <section className="relative min-h-[78vh] flex items-center justify-center px-6" style={{ background: theme.bannerSectionBackground || theme.primaryColor }}>
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${theme.heroImage})` }} />
        <div className="absolute inset-0" style={{ background: theme.heroOverlay, opacity: theme.heroOverlayOpacity }} />
        <div className="relative z-10 w-full max-w-3xl rounded-[2rem] border border-white/30 bg-white/12 backdrop-blur-sm px-8 py-14 text-center">
          <p className="text-[0.7rem] uppercase tracking-[0.35em]" style={{ color: theme.bannerTextColor || 'rgba(255,255,255,0.8)', fontFamily: theme.bannerTextFont }}>Nosso Casamento</p>
          <h1 className="mt-4 text-5xl md:text-6xl font-bold" style={{ color: theme.heroTitleColor, fontFamily: theme.bannerTitleFont }}>
            {site.couple_names}
          </h1>
          <p className="mt-5 text-lg" style={{ color: theme.bannerTextColor || theme.heroDateColor, fontFamily: theme.bannerTextFont }}>{weddingDateLabel}</p>
          {showCountdown ? (
            <div className="mt-8">
              <CountdownInline daysUntil={daysUntil} textColor={theme.heroTitleColor} />
            </div>
          ) : null}
          <Button
            onClick={() => (isTemplatePreview ? onTemplatePreviewRedirect?.() : onOpenRsvp?.())}
            className="mt-8 h-12 rounded-full px-10 font-semibold"
            style={{ background: theme.confirmButtonBackground, color: theme.confirmButtonText, borderColor: theme.confirmButtonBorder, borderWidth: 1, borderStyle: 'solid' }}
          >
            Confirmar Presença
          </Button>
        </div>
      </section>

      {renderGalleryByPosition(galleryPosition, 'after_hero', galleryNode)}

      <StoryBlock
        title="Nossa História"
        storyText={site.story_text}
        background={theme.storySectionBackground || '#FAF8F2'}
        titleColor={theme.storyTitleColor}
        bodyColor={theme.storyBodyColor}
        titleFont={theme.storyTitleFont}
        bodyFont={theme.storyBodyFont}
      />

      {renderGalleryByPosition(galleryPosition, 'after_story', galleryNode)}

      <LocationBlock
        locationCards={locationCards}
        headingFont={theme.headingFont}
        titleFont={theme.locationTitleFont || theme.headingFont}
        titleColor={theme.locationTitleColor}

        textColor={theme.locationTextColor}
        textFont={theme.locationTextFont}
        secondaryColor={theme.secondaryColor}
        sectionBackground={theme.locationSectionBackground || '#F8F6F4'}
        sectionIconColor={theme.locationIconColor || theme.locationTitleColor}
        cardBackground={theme.locationCardBackground}
        cardIconBackground={theme.locationIconColor || theme.locationTitleColor}
        cardTitleColor={theme.locationTitleColor}
        cardLinkColor={theme.locationIconColor || theme.locationTitleColor}
        cardClass="rounded-2xl border border-[#E8DCC8] bg-white shadow-sm"
      />

      {renderGalleryByPosition(galleryPosition, 'before_gifts', galleryNode)}

      <GiftsBlock
        gifts={availableGifts}
        headingFont={theme.headingFont}
        theme={theme}
        titleColor={theme.primaryColor}
        textColor={theme.bodyTextColor}
        secondaryColor={theme.secondaryColor}
        onGiftClick={onGiftClick}
        showGiftSection={showGiftSection}
      />

      {renderGalleryByPosition(galleryPosition, 'end', galleryNode)}

      <RsvpBlock
        onOpenRsvp={onOpenRsvp}
        isTemplatePreview={isTemplatePreview}
        onTemplatePreviewRedirect={onTemplatePreviewRedirect}
        primaryColor={theme.primaryColor}
        secondaryColor={theme.secondaryColor}
        sectionBackground={theme.rsvpSectionBackground}
        buttonBackground={theme.confirmButtonBackground}
        buttonText={theme.confirmButtonText}
        buttonBorder={theme.confirmButtonBorder}
        iconColor={theme.rsvpIconColor || theme.rsvpTextColor || theme.bodyTextColor}
        titleColor={theme.rsvpTextColor || theme.bodyTextColor}
        bodyColor={theme.rsvpTextColor || theme.bodyTextColor}
        countColor={theme.rsvpTextColor || theme.bodyTextColor}
        headingFont={theme.rsvpTitleFont || theme.headingFont}
        bodyFont={theme.rsvpTextFont}
        showRsvpCount={showRsvpCount}
        confirmedGuests={confirmedGuests}
      />

      <SiteFooter coupleNames={site.couple_names} textColor={theme.bodyTextColor} />
    </>
  );
}

